interface Props {
  label: "A" | "B";
  children: string;
  selected?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

export function ChoiceCard({ label, children, selected, disabled, onClick }: Props) {
  return (
    <button className={`choice-card ${selected ? "is-selected" : ""}`} type="button" disabled={disabled} onClick={onClick}>
      <span className="choice-label">{label}</span>
      <span className="choice-copy">{children}</span>
      <span className="choice-arrow" aria-hidden="true">↗</span>
    </button>
  );
}
